<template>
  <article class="user_view">
    <left-menu :deleted="numberOfDeleted"></left-menu>
    <modal-rectify  @cancel="onCancelRectify" @activate="onActivateRectify" v-if="modalRectifyActive" :turno="selected" :type="'audio'"></modal-rectify>
    <section class="user_view__header" style="height: fit-content">
      <div @click="$router.push({ path: '/urgentlist'})" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>


      <div class="user_view__header--info"> 
        <div>
          <h1>Alertas de audios importantes</h1>
          <h4>Listado de audios para operador</h4>
          
        </div>
        <div>
          
          <div class="user_view__header--sec1" style="margin-top:0px">  
              <button :class="{'active':true}" @click="updateData()" class="secondary_button" >ACTUALIZAR</button>
          </div>
        </div>
        
      </div>
      <div style="width:100%; display:flex;justify-content:space-around;margin-top:15px" >
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>GUARDA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-12%"><b>PUESTO DE TRABAJO</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-9%"><b>AUDIO DE ALTA IMPORTANCIA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-right:-2%"><b>ACCIÓN</b></h3>
      </div>
      <div class="user_view__header--info" style="margin-top:21px"> 
        <div style="width:100%;max-height:66vh;overflow-y:scroll;">
          
          <div style="width:100%; display:inline-flex;" >
             <div style="width:100%;">
              
              
             
              <div class="user_view__header--audios" style="width:100%" >
                <div v-for="(aud,i) in importantAudios" :key="i" style="display:flex;border-bottom:1px dotted gray;">
                  <h4 style="position:relative; display:list-item;margin-top:33px;width:20%;cursor:pointer" @click="$router.push({ path: '/turn/'+ aud.turn })" ><b>■ <u>{{aud.guard}}</u></b></h4>
                  <h4 style="position:relative; margin-top:33px;width:20%;margin-left:20px">{{aud.location}}</h4>
                  <div class="user_view__header--audios--item" style="padding-left:0px;width:45%;margin-left:5px;margin-top:20px;height:33px;background-color: #c6cbd2; border: 3px solid crimson;right-padding:-33px">
                    <audio style="background:white; border-radius: 10px;height:38px;margin-left:3px "  controls>
                      <source :src="aud.link.url" type="audio/wav">
                      Your browser does not support the audio element.
                    </audio>
                    <h4 style="margin-left:10px;color:#4E5B71; font-size:10px ">{{aud.hour}}</h4>
                  </div>
                  <input type="radio"  @click="numberOfRow(i)" style="margin-top:33px;margin-left:20px;margin-right:20px;width:15%"  :id="'radio'+i" >  
                  
                </div>
                <h4  v-if="importantAudios.length == 0" style="text-align: center; margin-top:33px">
                    No se han encontrado audios con alta importancia.
                </h4>
              </div>
              
            </div>
             
              
            
          </div>      
        
         
        </div>   
            
      </div>
     
      
    </section>
    
  </article>
</template>

<script>
import moment from 'moment';
export default {
  data(){
    return{
      subtitulo:'Guarda           Radio Operador',
      reports:[],
      reportes:{},
      is_diurnal: true,
      importantAudios:[],
      audios:{high:[],normal:[]},
      modalRectifyActive:false,
      selected:null,
      reloading:true,
      numberOfDeleted:0,
    }
  }, 
  methods:{
    updateData(){
      const customActions={
        post: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
      };
      this.$resource('guards/dashboard',{},customActions).post({'company':this.$route.params.id})
      .then(function(data){
        console.log("REPORT");
        console.log(data);
        var allMyData=data.body.reverse();
        var audios=[];
        for(var element in allMyData){
          let newAudio={"id":allMyData[element].id,"link": allMyData[element].my_link.link , "hour": allMyData[element].my_link.hour, "guard":allMyData[element].guard, "location": allMyData[element].location,"turn":allMyData[element].turn_id}
          audios.push(newAudio);
        } 
        
        this.importantAudios=audios;
      });
    },
    numberOfRow(row){   
     
      this.selected=this.importantAudios[row];
      this.modalRectifyActive=true;
      document.getElementById("radio"+row).checked=false;
      
            
    },
    onCancelRectify(){
      this.modalRectifyActive=false;
    },
    onActivateRectify(data){
      var self=this;
      
      const customActions={
        review: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'DELETE'}                   
      };
      this.$resource('administrators/dashboard/'+self.selected.id,{
        comments: data[2],
        whoReviews: data[3]
      },customActions).review()
      .then(function(data){
        console.log('Audio revisado:', data.body)
        this.modalRectifyActive=false;       
        self.$router.go();
      });
    },
  },

  
  created(){
    const customActions={
        post: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
    };
    this.$resource('guards/dashboard',{},customActions).post({'company':this.$route.params.id})
    .then(function(data){
      console.log("REPORT");
      console.log(data);
      var allMyData=data.body.reverse();
      var audios=[];
      for(var element in allMyData){
        let newAudio={"id":allMyData[element].id,"link": allMyData[element].my_link.link , "hour": allMyData[element].my_link.hour, "guard":allMyData[element].guard, "location": allMyData[element].location,"turn":allMyData[element].turn_id}
        audios.push(newAudio);
      } 
      
      this.importantAudios=audios;
      // let normal = this.turn.audios.filter(audio=> audio.importance==0);

      // this.audios.high=high.reverse();
      // this.audios.normal=normal.reverse();


      // this.turn.audios.high=data
      // this.is_diurnal=data.body.is_diurnal;      
      // this.reportes=this.turn.report;
      // this.justification=this.turn.justification;
      // // console.log(this.reportes);
      // // console.log(this.justification)
      // var self=this;
      // var pos=-1;
      // this.justification.forEach(function(element){ 
        
      //   if(self.reportes[element.hour]){
      //     self.reportes[element.hour]["guard"]=(element.guard);
      //     self.reportes[element.hour]["justified"]=(element.justified);
      //   }
      //   let hours= self.reports.map(report => Number(report.hour));
      //   if(hours.includes(element.hour-1)){
      //     self.reports.splice(pos,0,element);
      //     pos+=1;
      //   }else{
      //     self.reports.unshift(element);
      //     pos=1;
      //   }
        
      // }); 
      
    });
    
  },

  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Urgent.vue